import { doRequest } from "utils/core";

const topAPI = {
  initTop: (params) => {
    let url = `api/top/init`;
    return doRequest("get", url, { params });
  },
  getPromotionsByGenre: (params) => {
    let url = `api/top/genre`;
    return doRequest("get", url, { params });
  },
};

export default topAPI;
